<template>
    <div class="customContainer">
        <h2 class="top__h201">INFORMATION</h2>
        <ul class="top__informations">
            <li class="top__information d-flex" v-for="(info, index) in lists" :key="index">
                <router-link class="top__informationLink d-flex" :to="'/information/' + info.id">
                <time class="top__informationTime" :datetime="info.set_date_date_label" v-if="set_date_check(info.set_date_date_val)">
                    {{ info.set_date_date_label }}
                </time>
                <p class="top__informationText_">{{ info.subject }}</p></router-link></li>
        </ul>
        <bs-page-nav v-if="displayPager" :pager_key="'information'" @to_click_event="pageAction"></bs-page-nav>
    </div>

</template>

<script>
// import BsPageTitle from '../molecules/BsPageTitle.vue'

import { mapState } from 'vuex'
import BsPageNav from '../../molecules/BsPageNav.vue'
export default {
    name: 'BsInformationTopView',
    data: function () {
        return {
            'tab_active': 'drive',//or th ead
        }
    },
    props: {
        displayPager: {
            type: Boolean,
            default: false
        },
    },
    components: {
        BsPageNav,
        // BsPageTitle,
    },
    methods: {
        loadLists () {
            // console.log('tag');
            const param = {};
            param['stat'] = [1];
            param['lang_type'] = this.app_lang_type;
            param['pagelimit'] = 4;
            param['pageorder'] = 'sort';
            return this.$store.dispatch('fetchBasicLists', {data: param, target: 'information'})
                .catch(err => Promise.reject(err))
                .then(() => {
                    console.log('loard complete department');
                    console.log('this', this.$store.state.apidata.information);
                })
                .finally(() => {
                    console.log('finally', this.$store.state.apidata.information);
                })
        },
    },
    computed: {
        ...mapState({
            lists: state => state.apidata.information,
            set_lang: state => state.apidata.set_lang,
            }
        ),
        set_date_check: function(){
            return function(value){
                if(
                    value != null 
                    && value != 'null' 
                    && value != '0000-00-00' 
                    && value != '' 
                    && value != false
                    && value != 'false' 
                ){
                    return true;
                }else{
                    return false;
                }
            }
        },
        app_lang_type: function (){
            // console.log('com')
            if(this.set_lang){
                return this.set_lang;
            }
            else{
                return this.$store.state.auth.app_lang_type;
            }
        },
    },
    created () {
        this.loadLists();
    },
}
</script>
